<main class="datasets">
  <app-header></app-header>
  <app-dataset-preview
    [showToolbar]="true"
    [showButtonGroup]="false"
  ></app-dataset-preview>
  <app-footer></app-footer>
</main>
